import { useMutation } from "@tanstack/react-query";
import { ApiError, ApiServiceError } from "libs/api";
import { MutationOptions, useRefetchQuery } from "libs/reactQuery";

import { requestDeleteReseller } from "./deleteReseller.request";

const useDeleteReseller = (
  options?: MutationOptions<void, ApiServiceError<ApiError>>
) => {
  const refetchResellersAndCounters = useRefetchQuery(["reseller"]);

  return useMutation({
    mutationFn: requestDeleteReseller,
    ...options,
    onSuccess: (...args) => {
      refetchResellersAndCounters();
      options?.onSuccess?.(...args);
    }
  });
};

export default useDeleteReseller;
